import { SidebarActions } from "@/components/layout/SidebarActions";
import Button from "@scripts/react/components/Button";
import { BuildStep, Flow, DeployStep } from "@/types/flows";
import { useAnalytics } from "@/contexts/AnalyticsContext";
import { useFlow } from "@/contexts/FlowContext";
import { DEFAULT_DURATION } from "@/constants/motion";
import { useFlowState } from "@/hooks/useFlowState";
import { AnalyticsFlowEvent } from "@/analytics/types";
import { useCallback } from "react";
import { useCurrentMedia } from "@/store";
import { usePageNavigationShortcut } from "@/hooks/usePageNavigationShortcut";

export const IntegrateSidebarActions = ({
    previousFlow,
    previousStep
}: {
    previousFlow: Flow;
    previousStep: BuildStep | DeployStep;
}) => {
    const { task } = useFlow();
    const { setStep, flow, step } = useFlowState();
    const { track } = useAnalytics();
    const currentMedia = useCurrentMedia();
    const handleBackClick = useCallback(() => {
        track({
            event: AnalyticsFlowEvent.BACK,
            data: { task, from: { flow, step }, to: { flow: previousFlow, step: previousStep } }
        });

        setStep({ flow: previousFlow, step: previousStep });
    }, [track, task, flow, step, previousFlow, previousStep, setStep]);

    // Keyboard shortcut: Command + Left Arrow
    usePageNavigationShortcut("left", handleBackClick, !currentMedia?.file);

    return (
        <SidebarActions
            toolbarProps={{
                initial: { opacity: 0 },
                animate: { opacity: true ? 1 : 0 },
                transition: { duration: DEFAULT_DURATION.slower, ease: "easeOut" }
            }}
        >
            {!!currentMedia?.file && (
                <Button type="secondary" onClick={handleBackClick}>
                    <i className="far fa-arrow-left"></i>
                    <span>Back</span>
                    <div className="hotkeysContainer">
                        <span className="hotkey">⌘</span>
                        <span className="hotkey">←</span>
                    </div>
                </Button>
            )}
        </SidebarActions>
    );
};
